import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { active: String }

  connect() {
    this.updateActiveState()
  }

  activate(event) {
    event.preventDefault()
    const folder = event.currentTarget.dataset.folder
    this.activeValue = folder
    this.updateActiveState()
  }

  updateActiveState() {
    this.itemTargets.forEach((item) => {
      const folder = item.dataset.folder
      const isActive = folder === this.activeValue
      
      if (isActive) {
        item.classList.add("bg-primary/5", "before:!h-full")
      } else {
        item.classList.remove("bg-primary/5", "before:!h-full")
      }
    })
  }
}
